// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:host {
  display: block;
  min-width: 0;
  color: var(--ca-text-primary, #172033);
}

.breadcrumb {
  margin: 1.25rem 1.5rem 0;
}

.breadcrumb-nav {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  margin: 0 0 0.75rem;
  color: var(--ca-text-tertiary, #6f7b91);
  font-size: 0.875rem;
}

.breadcrumb-current {
  display: inline-flex;
  align-items: center;
  gap: 0.25rem;
  color: var(--ca-text-secondary, #4b5870);
  font-weight: 500;
}

.breadcrumb-current i {
  color: var(--ca-primary, #0e2e80);
  font-size: 1.25rem;
}

.assets-view-page {
  width: 100%;
  max-width: 100%;
  min-width: 0;
  margin: 0 auto;
  padding: 1rem 1.5rem 1.75rem;
}

.page-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 1.25rem;
  margin-bottom: 1.25rem;
}

.page-heading {
  min-width: 0;
}

.page-heading h1 {
  margin: 0 0 0.35rem;
  color: var(--ca-text-primary, #172033);
  font-size: clamp(1.4rem, 2vw, 1.8rem);
  font-weight: 700;
  letter-spacing: -0.025em;
  line-height: 1.3;
}

.page-heading p {
  margin: 0;
  color: var(--ca-text-secondary, #4b5870);
  font-size: 0.9rem;
  line-height: 1.55;
}

.page-header-meta {
  display: flex;
  flex: 0 0 auto;
  align-items: center;
  gap: 0.75rem;
  min-width: 10.5rem;
  padding: 0.7rem 0.9rem;
  border: 1px solid var(--ca-border-light, #e9edf3);
  border-radius: var(--ca-radius-md, 8px);
  background: var(--ca-surface, #fff);
  box-shadow: var(--ca-shadow-sm, 0 2px 6px rgba(7, 17, 46, 0.06));
}

.header-meta-icon {
  display: grid;
  width: 2.4rem;
  height: 2.4rem;
  flex: 0 0 2.4rem;
  place-items: center;
  border-radius: var(--ca-radius-sm, 6px);
  background: var(--ca-surface-active, #eef3ff);
  color: var(--ca-primary, #0e2e80);
  font-size: 1.1rem;
}

.page-header-meta > div {
  display: flex;
  flex-direction: column;
  min-width: 0;
}

.page-header-meta strong {
  color: var(--ca-text-primary, #172033);
  font-size: 1.1rem;
  line-height: 1.2;
}

.page-header-meta span:not(.header-meta-icon) {
  color: var(--ca-text-tertiary, #6f7b91);
  font-size: 0.72rem;
  white-space: nowrap;
}

.assets-view-card {
  min-width: 0;
  overflow: hidden;
  border: 1px solid var(--ca-border-light, #e9edf3);
  border-radius: var(--ca-radius-lg, 12px);
  background: var(--ca-surface, #fff);
  box-shadow: var(--ca-shadow-sm, 0 2px 6px rgba(7, 17, 46, 0.06));
}

.asset-tabs {
  display: flex;
  align-items: stretch;
  gap: 0.35rem;
  padding: 0.65rem 1.25rem 0;
  border-bottom: 1px solid var(--ca-border-light, #e9edf3);
  background: linear-gradient(180deg, #fff 0%, #fbfcff 100%);
}

.asset-tab {
  position: relative;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 0.6rem;
  min-height: 3.1rem;
  padding: 0.75rem 1rem 0.9rem;
  border: 0;
  border-radius: var(--ca-radius-sm, 6px) var(--ca-radius-sm, 6px) 0 0;
  background: transparent;
  color: var(--ca-text-secondary, #4b5870);
  font: inherit;
  font-size: 0.88rem;
  font-weight: 600;
  cursor: pointer;
  transition: color 0.15s ease, background-color 0.15s ease;
}

.asset-tab i {
  color: var(--ca-text-muted, #8c96a8);
  font-size: 1.05rem;
}

.asset-tab:hover {
  background: var(--ca-surface-hover, #f8faff);
  color: var(--ca-primary, #0e2e80);
}

.asset-tab.active {
  background: var(--ca-surface, #fff);
  color: var(--ca-primary, #0e2e80);
}

.asset-tab.active::after {
  position: absolute;
  right: 0.75rem;
  bottom: -1px;
  left: 0.75rem;
  height: 3px;
  border-radius: 3px 3px 0 0;
  background: var(--ca-primary, #0e2e80);
  content: "";
}

.asset-tab.active i {
  color: var(--ca-primary, #0e2e80);
}

.tab-count {
  display: inline-flex;
  min-width: 1.5rem;
  height: 1.35rem;
  align-items: center;
  justify-content: center;
  padding: 0 0.35rem;
  border-radius: 999px;
  background: var(--ca-bg-secondary, #eef2f8);
  color: var(--ca-text-secondary, #4b5870);
  font-size: 0.7rem;
  font-weight: 700;
}

.asset-tab.active .tab-count {
  background: var(--ca-surface-active, #eef3ff);
  color: var(--ca-primary, #0e2e80);
}

.tab-panel {
  min-width: 0;
  padding: 1.25rem;
}

.list-heading {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 1.25rem;
  margin-bottom: 1.25rem;
}

.section-eyebrow {
  margin-bottom: 0.35rem;
  color: var(--ca-primary-light, #2850ad);
  font-size: 0.68rem;
  font-weight: 800;
  letter-spacing: 0.1em;
}

.list-heading h2 {
  margin: 0 0 0.3rem;
  color: var(--ca-text-primary, #172033);
  font-size: 1.15rem;
  font-weight: 700;
}

.list-heading p {
  margin: 0;
  color: var(--ca-text-secondary, #4b5870);
  font-size: 0.82rem;
  line-height: 1.5;
}

.verification-actions {
  display: flex;
  flex: 0 0 auto;
  flex-wrap: wrap;
  justify-content: flex-end;
  gap: 0.55rem;
}

.btn-primary,
.btn-secondary {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 0.5rem;
  min-height: 2.55rem;
  padding: 0.6rem 0.9rem;
  border-radius: var(--ca-radius-md, 8px);
  font-size: 0.82rem;
  font-weight: 600;
  white-space: nowrap;
  transition: background-color 0.15s ease, border-color 0.15s ease, box-shadow 0.15s ease;
}

.btn-primary {
  border: 1px solid var(--ca-primary, #0e2e80);
  background: var(--ca-primary, #0e2e80);
  color: #fff;
}

.btn-primary:hover:not(:disabled) {
  border-color: var(--ca-primary-dark, #0d2863);
  background: var(--ca-primary-dark, #0d2863);
  color: #fff;
}

.btn-secondary {
  border: 1px solid var(--ca-border, #dfe4ec);
  background: var(--ca-surface, #fff);
  color: var(--ca-primary, #0e2e80);
}

.btn-secondary:hover:not(:disabled) {
  border-color: var(--ca-primary, #0e2e80);
  background: var(--ca-surface-hover, #f8faff);
}

.btn-primary:disabled,
.btn-secondary:disabled {
  cursor: not-allowed;
  opacity: 0.55;
}

.btn-primary:focus-visible,
.btn-secondary:focus-visible,
.asset-tab:focus-visible {
  outline: 3px solid rgba(40, 80, 173, 0.25);
  outline-offset: 2px;
}

.search-toolbar {
  display: grid;
  grid-template-columns: minmax(16rem, 1.5fr) minmax(13rem, 0.85fr) auto;
  gap: 0.75rem;
  margin-bottom: 1.1rem;
}

.search-field {
  display: flex;
  min-width: 0;
  align-items: stretch;
}

.search-control {
  width: 100%;
  min-width: 0;
  min-height: 2.65rem;
  border: 1px solid var(--ca-input-border, #dfe4ec);
  border-radius: var(--ca-radius-md, 8px);
  background: var(--ca-input-bg, #fff);
  color: var(--ca-text-primary, #172033);
  font-size: 0.875rem;
}

.search-control:focus {
  border-color: var(--ca-input-focus, #2850ad);
  box-shadow: 0 0 0 0.2rem rgba(40, 80, 173, 0.15);
  outline: 0;
}

.search-control::placeholder {
  color: var(--ca-text-muted, #8c96a8);
}

.search-field .search-control {
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
}

.search-submit {
  display: inline-grid;
  width: 2.75rem;
  flex: 0 0 2.75rem;
  place-items: center;
  border: 1px solid var(--ca-primary, #0e2e80);
  border-radius: 0 var(--ca-radius-md, 8px) var(--ca-radius-md, 8px) 0;
  background: var(--ca-primary, #0e2e80);
  color: #fff;
  cursor: pointer;
  transition: background-color 0.15s ease;
}

.search-submit:hover {
  background: var(--ca-primary-dark, #0d2863);
}

.clear-search {
  align-self: stretch;
}

.table-region {
  min-width: 0;
  overflow: hidden;
}

.main-table-wrapper {
  width: 100%;
  min-width: 0;
  max-width: 100%;
  overflow-x: auto;
  border: 1px solid var(--ca-border-light, #e9edf3);
  border-radius: var(--ca-radius-md, 8px);
}

.table-responsive {
  max-width: 100%;
  border: 1px solid var(--ca-border-light, #e9edf3);
  border-radius: var(--ca-radius-md, 8px);
}

.assets-table {
  min-width: 1050px;
  margin: 0;
  color: var(--ca-text-primary, #172033);
  font-size: 0.82rem;
}

.assets-table thead th {
  padding: 0.9rem 0.75rem;
  border-bottom: 1px solid var(--ca-border, #dfe4ec);
  background: var(--ca-bg-secondary, #eef2f8);
  color: var(--ca-text-secondary, #4b5870);
  font-size: 0.69rem;
  font-weight: 750;
  letter-spacing: 0.035em;
  text-transform: uppercase;
  white-space: nowrap;
}

.assets-table tbody td {
  max-width: 19rem;
  padding: 0.8rem 0.75rem;
  border-bottom: 1px solid var(--ca-border-light, #e9edf3);
  color: var(--ca-text-secondary, #4b5870);
  vertical-align: middle;
}

.assets-table tbody tr:last-child td {
  border-bottom: 0;
}

.assets-table tbody tr {
  transition: background-color 0.15s ease;
}

.assets-table tbody tr:hover {
  background: var(--ca-surface-hover, #f8faff);
}

.assets-table td.primary-cell {
  color: var(--ca-text-primary, #172033);
  font-weight: 650;
}

.identifier-cell {
  display: inline-block;
  max-width: 18rem;
  overflow: hidden;
  text-overflow: ellipsis;
  vertical-align: bottom;
  white-space: nowrap;
}

.status-pill {
  display: inline-flex;
  align-items: center;
  max-width: 100%;
  padding: 0.25rem 0.55rem;
  border: 1px solid var(--ca-border, #dfe4ec);
  border-radius: 999px;
  background: var(--ca-bg-secondary, #eef2f8);
  color: var(--ca-text-secondary, #4b5870);
  font-size: 0.7rem;
  font-weight: 700;
  line-height: 1.2;
  white-space: nowrap;
}

.status-good {
  border-color: #b7e3ca;
  background: #eaf7f0;
  color: #198754;
}

.status-warning {
  border-color: #f3d79b;
  background: #fff7e6;
  color: #986400;
}

.status-danger {
  border-color: #f3b9c0;
  background: #fdecef;
  color: #b42332;
}

.status-neutral {
  border-color: var(--ca-border, #dfe4ec);
  background: var(--ca-bg-secondary, #eef2f8);
  color: var(--ca-text-secondary, #4b5870);
}

.inline-loading {
  display: flex;
  min-height: 4.5rem;
  align-items: center;
  gap: 0.65rem;
  color: var(--ca-text-secondary, #4b5870);
  font-size: 0.875rem;
}

.inline-error {
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: 0.75rem;
  margin: 0.75rem 0;
  padding: 0.85rem 1rem;
  border: 1px solid var(--ca-danger, #dc3545);
  border-radius: var(--ca-radius-md, 8px);
  background: var(--ca-danger-bg, #fdecef);
  color: var(--ca-text-primary, #172033);
  font-size: 0.85rem;
}

.inline-retry {
  padding: 0;
  border: 0;
  background: transparent;
  color: var(--ca-primary, #0e2e80);
  font-weight: 700;
  text-decoration: underline;
  cursor: pointer;
}

.state-panel,
.no-results {
  display: flex;
  min-height: 15rem;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 0.65rem;
  padding: 2rem 1rem;
  color: var(--ca-text-tertiary, #6f7b91);
  text-align: center;
}

.state-panel > i,
.no-results > i {
  color: var(--ca-primary-light, #2850ad);
  font-size: 2rem;
}

.state-panel h3,
.no-results h3 {
  margin: 0;
  color: var(--ca-text-primary, #172033);
  font-size: 1rem;
  font-weight: 700;
}

.state-panel p,
.no-results p {
  max-width: 30rem;
  margin: 0 0 0.5rem;
  color: var(--ca-text-secondary, #4b5870);
  font-size: 0.875rem;
  line-height: 1.6;
}

.error-state > i {
  color: var(--ca-danger, #dc3545);
}

.loading-spinner {
  display: inline-block;
  width: 2rem;
  height: 2rem;
  border: 3px solid var(--ca-border, #dfe4ec);
  border-top-color: var(--ca-primary, #0e2e80);
  border-radius: 50%;
  animation: assets-view-spin 0.8s linear infinite;
}

.loading-spinner-sm {
  width: 1.1rem;
  height: 1.1rem;
  border-width: 2px;
}

.list-footer {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 1rem;
  margin-top: 1.15rem;
  padding-top: 1rem;
  border-top: 1px solid var(--ca-border-light, #e9edf3);
}

.pagination-summary {
  color: var(--ca-text-tertiary, #6f7b91);
  font-size: 0.78rem;
}

@keyframes assets-view-spin {
  to {
    transform: rotate(360deg);
  }
}
@media (max-width: 1100px) {
  .list-heading {
    flex-direction: column;
    align-items: stretch;
  }
  .verification-actions {
    justify-content: flex-start;
  }
  .search-toolbar {
    grid-template-columns: minmax(0, 1fr) minmax(12rem, 0.8fr);
  }
  .clear-search {
    grid-column: 1/-1;
    justify-self: start;
  }
}
@media (max-width: 767.98px) {
  .breadcrumb {
    margin: 0.75rem 1rem 0;
  }
  .assets-view-page {
    padding: 0.75rem 1rem 1.25rem;
  }
  .page-header {
    align-items: flex-start;
    flex-direction: column;
  }
  .page-header-meta {
    align-self: flex-start;
  }
  .asset-tabs {
    gap: 0.1rem;
    padding-inline: 0.5rem;
  }
  .asset-tab {
    flex: 1 1 50%;
    gap: 0.4rem;
    padding-inline: 0.45rem;
    font-size: 0.8rem;
  }
  .tab-panel {
    padding: 0.9rem;
  }
  .verification-actions {
    display: grid;
    grid-template-columns: minmax(0, 1fr);
  }
  .verification-actions .btn {
    justify-content: flex-start;
    white-space: normal;
  }
  .search-toolbar {
    grid-template-columns: minmax(0, 1fr);
  }
  .clear-search {
    grid-column: auto;
    justify-self: start;
  }
  .list-footer {
    align-items: stretch;
    flex-direction: column;
  }
  .list-footer app-pagination {
    align-self: flex-end;
    max-width: 100%;
  }
}
@media (prefers-reduced-motion: reduce) {
  *,
  *::before,
  *::after {
    animation-duration: 0.01ms !important;
    animation-iteration-count: 1 !important;
    scroll-behavior: auto !important;
    transition-duration: 0.01ms !important;
  }
}
/* Verification-result modal content rendered through MatDialog. */
.verification-result-dialog {
  padding: 2rem;
  text-align: center;
}

.verification-result-icon {
  display: grid;
  width: 3.5rem;
  height: 3.5rem;
  place-items: center;
  margin: 0 auto 1rem;
  border: 1px solid var(--ca-border-light, #e9edf3);
  border-radius: 50%;
  background: var(--ca-bg-secondary, #eef2f8);
  color: var(--ca-text-secondary, #4b5870);
  font-size: 1.8rem;
}

.verification-result-icon.is-success {
  border-color: #b7e3ca;
  background: #eaf7f0;
  color: #198754;
}

.verification-result-icon.is-error {
  border-color: #f3b9c0;
  background: #fdecef;
  color: #b42332;
}

.verification-result-dialog h2 {
  margin: 0 0 0.65rem;
  color: var(--ca-text-primary, #172033);
  font-size: 1.2rem;
  font-weight: 700;
}

.verification-result-dialog p {
  margin: 0;
  color: var(--ca-text-secondary, #4b5870);
  font-size: 0.92rem;
  line-height: 1.6;
  overflow-wrap: anywhere;
}

.verification-result-actions {
  display: flex;
  justify-content: center;
  margin-top: 1.5rem;
}

.verification-result-actions .btn {
  min-width: 8rem;
}

.verification-actions .loading-spinner-sm {
  flex: 0 0 auto;
}`, "",{"version":3,"sources":["webpack://./src/app/features/asset-management/assets-view/assets-view.component.scss"],"names":[],"mappings":"AAAA;EACE,cAAA;EACA,YAAA;EACA,sCAAA;AACF;;AAEA;EACE,wBAAA;AACF;;AAEA;EACE,aAAA;EACA,mBAAA;EACA,WAAA;EACA,mBAAA;EACA,uCAAA;EACA,mBAAA;AACF;;AAEA;EACE,oBAAA;EACA,mBAAA;EACA,YAAA;EACA,wCAAA;EACA,gBAAA;AACF;;AAEA;EACE,iCAAA;EACA,kBAAA;AACF;;AAEA;EACE,WAAA;EACA,eAAA;EACA,YAAA;EACA,cAAA;EACA,4BAAA;AACF;;AAEA;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,YAAA;EACA,sBAAA;AACF;;AAEA;EACE,YAAA;AACF;;AAEA;EACE,mBAAA;EACA,sCAAA;EACA,qCAAA;EACA,gBAAA;EACA,wBAAA;EACA,gBAAA;AACF;;AAEA;EACE,SAAA;EACA,wCAAA;EACA,iBAAA;EACA,iBAAA;AACF;;AAEA;EACE,aAAA;EACA,cAAA;EACA,mBAAA;EACA,YAAA;EACA,kBAAA;EACA,sBAAA;EACA,iDAAA;EACA,uCAAA;EACA,mCAAA;EACA,gEAAA;AACF;;AAEA;EACE,aAAA;EACA,aAAA;EACA,cAAA;EACA,gBAAA;EACA,mBAAA;EACA,uCAAA;EACA,6CAAA;EACA,iCAAA;EACA,iBAAA;AACF;;AAEA;EACE,aAAA;EACA,sBAAA;EACA,YAAA;AACF;;AAEA;EACE,sCAAA;EACA,iBAAA;EACA,gBAAA;AACF;;AAEA;EACE,uCAAA;EACA,kBAAA;EACA,mBAAA;AACF;;AAEA;EACE,YAAA;EACA,gBAAA;EACA,iDAAA;EACA,wCAAA;EACA,mCAAA;EACA,gEAAA;AACF;;AAEA;EACE,aAAA;EACA,oBAAA;EACA,YAAA;EACA,0BAAA;EACA,wDAAA;EACA,0DAAA;AACF;;AAEA;EACE,kBAAA;EACA,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,WAAA;EACA,kBAAA;EACA,4BAAA;EACA,SAAA;EACA,oEAAA;EACA,uBAAA;EACA,wCAAA;EACA,aAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,yDAAA;AACF;;AAEA;EACE,oCAAA;EACA,kBAAA;AACF;;AAEA;EACE,4CAAA;EACA,iCAAA;AACF;;AAEA;EACE,mCAAA;EACA,iCAAA;AACF;;AAEA;EACE,kBAAA;EACA,cAAA;EACA,YAAA;EACA,aAAA;EACA,WAAA;EACA,0BAAA;EACA,sCAAA;EACA,WAAA;AACF;;AAEA;EACE,iCAAA;AACF;;AAEA;EACE,oBAAA;EACA,iBAAA;EACA,eAAA;EACA,mBAAA;EACA,uBAAA;EACA,kBAAA;EACA,oBAAA;EACA,2CAAA;EACA,wCAAA;EACA,iBAAA;EACA,gBAAA;AACF;;AAEA;EACE,6CAAA;EACA,iCAAA;AACF;;AAEA;EACE,YAAA;EACA,gBAAA;AACF;;AAEA;EACE,aAAA;EACA,uBAAA;EACA,8BAAA;EACA,YAAA;EACA,sBAAA;AACF;;AAEA;EACE,sBAAA;EACA,uCAAA;EACA,kBAAA;EACA,gBAAA;EACA,qBAAA;AACF;;AAEA;EACE,kBAAA;EACA,sCAAA;EACA,kBAAA;EACA,gBAAA;AACF;;AAEA;EACE,SAAA;EACA,wCAAA;EACA,kBAAA;EACA,gBAAA;AACF;;AAEA;EACE,aAAA;EACA,cAAA;EACA,eAAA;EACA,yBAAA;EACA,YAAA;AACF;;AAEA;;EAEE,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,WAAA;EACA,mBAAA;EACA,sBAAA;EACA,uCAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;EACA,uFAAA;AACF;;AAEA;EACE,4CAAA;EACA,sCAAA;EACA,WAAA;AACF;;AAEA;EACE,6CAAA;EACA,2CAAA;EACA,WAAA;AACF;;AAEA;EACE,2CAAA;EACA,mCAAA;EACA,iCAAA;AACF;;AAEA;EACE,wCAAA;EACA,4CAAA;AACF;;AAEA;;EAEE,mBAAA;EACA,aAAA;AACF;;AAEA;;;EAGE,0CAAA;EACA,mBAAA;AACF;;AAEA;EACE,aAAA;EACA,sEAAA;EACA,YAAA;EACA,qBAAA;AACF;;AAEA;EACE,aAAA;EACA,YAAA;EACA,oBAAA;AACF;;AAEA;EACE,WAAA;EACA,YAAA;EACA,mBAAA;EACA,iDAAA;EACA,uCAAA;EACA,oCAAA;EACA,sCAAA;EACA,mBAAA;AACF;;AAEA;EACE,4CAAA;EACA,gDAAA;EACA,UAAA;AACF;;AAEA;EACE,oCAAA;AACF;;AAEA;EACE,0BAAA;EACA,6BAAA;AACF;;AAEA;EACE,oBAAA;EACA,cAAA;EACA,iBAAA;EACA,mBAAA;EACA,4CAAA;EACA,oEAAA;EACA,sCAAA;EACA,WAAA;EACA,eAAA;EACA,uCAAA;AACF;;AAEA;EACE,2CAAA;AACF;;AAEA;EACE,mBAAA;AACF;;AAEA;EACE,YAAA;EACA,gBAAA;AACF;;AAEA;EACE,WAAA;EACA,YAAA;EACA,eAAA;EACA,gBAAA;EACA,iDAAA;EACA,uCAAA;AACF;;AAEA;EACE,eAAA;EACA,iDAAA;EACA,uCAAA;AACF;;AAEA;EACE,iBAAA;EACA,SAAA;EACA,sCAAA;EACA,kBAAA;AACF;;AAEA;EACE,uBAAA;EACA,kDAAA;EACA,2CAAA;EACA,wCAAA;EACA,kBAAA;EACA,gBAAA;EACA,uBAAA;EACA,yBAAA;EACA,mBAAA;AACF;;AAEA;EACE,gBAAA;EACA,uBAAA;EACA,wDAAA;EACA,wCAAA;EACA,sBAAA;AACF;;AAEA;EACE,gBAAA;AACF;;AAEA;EACE,uCAAA;AACF;;AAEA;EACE,4CAAA;AACF;;AAEA;EACE,sCAAA;EACA,gBAAA;AACF;;AAEA;EACE,qBAAA;EACA,gBAAA;EACA,gBAAA;EACA,uBAAA;EACA,sBAAA;EACA,mBAAA;AACF;;AAEA;EACE,oBAAA;EACA,mBAAA;EACA,eAAA;EACA,wBAAA;EACA,2CAAA;EACA,oBAAA;EACA,2CAAA;EACA,wCAAA;EACA,iBAAA;EACA,gBAAA;EACA,gBAAA;EACA,mBAAA;AACF;;AAEA;EACE,qBAAA;EACA,mBAAA;EACA,cAAA;AACF;;AAEA;EACE,qBAAA;EACA,mBAAA;EACA,cAAA;AACF;;AAEA;EACE,qBAAA;EACA,mBAAA;EACA,cAAA;AACF;;AAEA;EACE,uCAAA;EACA,2CAAA;EACA,wCAAA;AACF;;AAEA;EACE,aAAA;EACA,kBAAA;EACA,mBAAA;EACA,YAAA;EACA,wCAAA;EACA,mBAAA;AACF;;AAEA;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,eAAA;EACA,YAAA;EACA,iBAAA;EACA,qBAAA;EACA,2CAAA;EACA,uCAAA;EACA,wCAAA;EACA,sCAAA;EACA,kBAAA;AACF;;AAEA;EACE,UAAA;EACA,SAAA;EACA,uBAAA;EACA,iCAAA;EACA,gBAAA;EACA,0BAAA;EACA,eAAA;AACF;;AAEA;;EAEE,aAAA;EACA,iBAAA;EACA,sBAAA;EACA,mBAAA;EACA,uBAAA;EACA,YAAA;EACA,kBAAA;EACA,uCAAA;EACA,kBAAA;AACF;;AAEA;;EAEE,uCAAA;EACA,eAAA;AACF;;AAEA;;EAEE,SAAA;EACA,sCAAA;EACA,eAAA;EACA,gBAAA;AACF;;AAEA;;EAEE,gBAAA;EACA,kBAAA;EACA,wCAAA;EACA,mBAAA;EACA,gBAAA;AACF;;AAEA;EACE,gCAAA;AACF;;AAEA;EACE,qBAAA;EACA,WAAA;EACA,YAAA;EACA,2CAAA;EACA,4CAAA;EACA,kBAAA;EACA,gDAAA;AACF;;AAEA;EACE,aAAA;EACA,cAAA;EACA,iBAAA;AACF;;AAEA;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,SAAA;EACA,mBAAA;EACA,iBAAA;EACA,qDAAA;AACF;;AAEA;EACE,uCAAA;EACA,kBAAA;AACF;;AAEA;EACE;IAAK,yBAAA;EAEL;AACF;AAAA;EACE;IACE,sBAAA;IACA,oBAAA;EAEF;EACA;IACE,2BAAA;EACF;EAEA;IACE,0DAAA;EAAF;EAGA;IACE,iBAAA;IACA,mBAAA;EADF;AACF;AAIA;EACE;IACE,sBAAA;EAFF;EAKA;IACE,6BAAA;EAHF;EAMA;IACE,uBAAA;IACA,sBAAA;EAJF;EAOA;IACE,sBAAA;EALF;EAQA;IACE,WAAA;IACA,sBAAA;EANF;EASA;IACE,aAAA;IACA,WAAA;IACA,uBAAA;IACA,iBAAA;EAPF;EAUA;IACE,eAAA;EARF;EAWA;IACE,aAAA;IACA,qCAAA;EATF;EAYA;IACE,2BAAA;IACA,mBAAA;EAVF;EAaA;IACE,qCAAA;EAXF;EAcA;IACE,iBAAA;IACA,mBAAA;EAZF;EAeA;IACE,oBAAA;IACA,sBAAA;EAbF;EAgBA;IACE,oBAAA;IACA,eAAA;EAdF;AACF;AAiBA;EACE;;;IAGE,qCAAA;IACA,uCAAA;IACA,gCAAA;IACA,sCAAA;EAfF;AACF;AAmBA,kEAAA;AACA;EACE,aAAA;EACA,kBAAA;AAjBF;;AAoBA;EACE,aAAA;EACA,aAAA;EACA,cAAA;EACA,mBAAA;EACA,mBAAA;EACA,iDAAA;EACA,kBAAA;EACA,2CAAA;EACA,wCAAA;EACA,iBAAA;AAjBF;;AAoBA;EACE,qBAAA;EACA,mBAAA;EACA,cAAA;AAjBF;;AAoBA;EACE,qBAAA;EACA,mBAAA;EACA,cAAA;AAjBF;;AAoBA;EACE,mBAAA;EACA,sCAAA;EACA,iBAAA;EACA,gBAAA;AAjBF;;AAoBA;EACE,SAAA;EACA,wCAAA;EACA,kBAAA;EACA,gBAAA;EACA,uBAAA;AAjBF;;AAoBA;EACE,aAAA;EACA,uBAAA;EACA,kBAAA;AAjBF;;AAoBA;EACE,eAAA;AAjBF;;AAoBA;EACE,cAAA;AAjBF","sourcesContent":[":host {\n  display: block;\n  min-width: 0;\n  color: var(--ca-text-primary, #172033);\n}\n\n.breadcrumb {\n  margin: 1.25rem 1.5rem 0;\n}\n\n.breadcrumb-nav {\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n  margin: 0 0 0.75rem;\n  color: var(--ca-text-tertiary, #6f7b91);\n  font-size: 0.875rem;\n}\n\n.breadcrumb-current {\n  display: inline-flex;\n  align-items: center;\n  gap: 0.25rem;\n  color: var(--ca-text-secondary, #4b5870);\n  font-weight: 500;\n}\n\n.breadcrumb-current i {\n  color: var(--ca-primary, #0e2e80);\n  font-size: 1.25rem;\n}\n\n.assets-view-page {\n  width: 100%;\n  max-width: 100%;\n  min-width: 0;\n  margin: 0 auto;\n  padding: 1rem 1.5rem 1.75rem;\n}\n\n.page-header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 1.25rem;\n  margin-bottom: 1.25rem;\n}\n\n.page-heading {\n  min-width: 0;\n}\n\n.page-heading h1 {\n  margin: 0 0 0.35rem;\n  color: var(--ca-text-primary, #172033);\n  font-size: clamp(1.4rem, 2vw, 1.8rem);\n  font-weight: 700;\n  letter-spacing: -0.025em;\n  line-height: 1.3;\n}\n\n.page-heading p {\n  margin: 0;\n  color: var(--ca-text-secondary, #4b5870);\n  font-size: 0.9rem;\n  line-height: 1.55;\n}\n\n.page-header-meta {\n  display: flex;\n  flex: 0 0 auto;\n  align-items: center;\n  gap: 0.75rem;\n  min-width: 10.5rem;\n  padding: 0.7rem 0.9rem;\n  border: 1px solid var(--ca-border-light, #e9edf3);\n  border-radius: var(--ca-radius-md, 8px);\n  background: var(--ca-surface, #fff);\n  box-shadow: var(--ca-shadow-sm, 0 2px 6px rgba(7, 17, 46, 0.06));\n}\n\n.header-meta-icon {\n  display: grid;\n  width: 2.4rem;\n  height: 2.4rem;\n  flex: 0 0 2.4rem;\n  place-items: center;\n  border-radius: var(--ca-radius-sm, 6px);\n  background: var(--ca-surface-active, #eef3ff);\n  color: var(--ca-primary, #0e2e80);\n  font-size: 1.1rem;\n}\n\n.page-header-meta > div {\n  display: flex;\n  flex-direction: column;\n  min-width: 0;\n}\n\n.page-header-meta strong {\n  color: var(--ca-text-primary, #172033);\n  font-size: 1.1rem;\n  line-height: 1.2;\n}\n\n.page-header-meta span:not(.header-meta-icon) {\n  color: var(--ca-text-tertiary, #6f7b91);\n  font-size: 0.72rem;\n  white-space: nowrap;\n}\n\n.assets-view-card {\n  min-width: 0;\n  overflow: hidden;\n  border: 1px solid var(--ca-border-light, #e9edf3);\n  border-radius: var(--ca-radius-lg, 12px);\n  background: var(--ca-surface, #fff);\n  box-shadow: var(--ca-shadow-sm, 0 2px 6px rgba(7, 17, 46, 0.06));\n}\n\n.asset-tabs {\n  display: flex;\n  align-items: stretch;\n  gap: 0.35rem;\n  padding: 0.65rem 1.25rem 0;\n  border-bottom: 1px solid var(--ca-border-light, #e9edf3);\n  background: linear-gradient(180deg, #fff 0%, #fbfcff 100%);\n}\n\n.asset-tab {\n  position: relative;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  gap: 0.6rem;\n  min-height: 3.1rem;\n  padding: 0.75rem 1rem 0.9rem;\n  border: 0;\n  border-radius: var(--ca-radius-sm, 6px) var(--ca-radius-sm, 6px) 0 0;\n  background: transparent;\n  color: var(--ca-text-secondary, #4b5870);\n  font: inherit;\n  font-size: 0.88rem;\n  font-weight: 600;\n  cursor: pointer;\n  transition: color 0.15s ease, background-color 0.15s ease;\n}\n\n.asset-tab i {\n  color: var(--ca-text-muted, #8c96a8);\n  font-size: 1.05rem;\n}\n\n.asset-tab:hover {\n  background: var(--ca-surface-hover, #f8faff);\n  color: var(--ca-primary, #0e2e80);\n}\n\n.asset-tab.active {\n  background: var(--ca-surface, #fff);\n  color: var(--ca-primary, #0e2e80);\n}\n\n.asset-tab.active::after {\n  position: absolute;\n  right: 0.75rem;\n  bottom: -1px;\n  left: 0.75rem;\n  height: 3px;\n  border-radius: 3px 3px 0 0;\n  background: var(--ca-primary, #0e2e80);\n  content: '';\n}\n\n.asset-tab.active i {\n  color: var(--ca-primary, #0e2e80);\n}\n\n.tab-count {\n  display: inline-flex;\n  min-width: 1.5rem;\n  height: 1.35rem;\n  align-items: center;\n  justify-content: center;\n  padding: 0 0.35rem;\n  border-radius: 999px;\n  background: var(--ca-bg-secondary, #eef2f8);\n  color: var(--ca-text-secondary, #4b5870);\n  font-size: 0.7rem;\n  font-weight: 700;\n}\n\n.asset-tab.active .tab-count {\n  background: var(--ca-surface-active, #eef3ff);\n  color: var(--ca-primary, #0e2e80);\n}\n\n.tab-panel {\n  min-width: 0;\n  padding: 1.25rem;\n}\n\n.list-heading {\n  display: flex;\n  align-items: flex-start;\n  justify-content: space-between;\n  gap: 1.25rem;\n  margin-bottom: 1.25rem;\n}\n\n.section-eyebrow {\n  margin-bottom: 0.35rem;\n  color: var(--ca-primary-light, #2850ad);\n  font-size: 0.68rem;\n  font-weight: 800;\n  letter-spacing: 0.1em;\n}\n\n.list-heading h2 {\n  margin: 0 0 0.3rem;\n  color: var(--ca-text-primary, #172033);\n  font-size: 1.15rem;\n  font-weight: 700;\n}\n\n.list-heading p {\n  margin: 0;\n  color: var(--ca-text-secondary, #4b5870);\n  font-size: 0.82rem;\n  line-height: 1.5;\n}\n\n.verification-actions {\n  display: flex;\n  flex: 0 0 auto;\n  flex-wrap: wrap;\n  justify-content: flex-end;\n  gap: 0.55rem;\n}\n\n.btn-primary,\n.btn-secondary {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  gap: 0.5rem;\n  min-height: 2.55rem;\n  padding: 0.6rem 0.9rem;\n  border-radius: var(--ca-radius-md, 8px);\n  font-size: 0.82rem;\n  font-weight: 600;\n  white-space: nowrap;\n  transition: background-color 0.15s ease, border-color 0.15s ease, box-shadow 0.15s ease;\n}\n\n.btn-primary {\n  border: 1px solid var(--ca-primary, #0e2e80);\n  background: var(--ca-primary, #0e2e80);\n  color: #fff;\n}\n\n.btn-primary:hover:not(:disabled) {\n  border-color: var(--ca-primary-dark, #0d2863);\n  background: var(--ca-primary-dark, #0d2863);\n  color: #fff;\n}\n\n.btn-secondary {\n  border: 1px solid var(--ca-border, #dfe4ec);\n  background: var(--ca-surface, #fff);\n  color: var(--ca-primary, #0e2e80);\n}\n\n.btn-secondary:hover:not(:disabled) {\n  border-color: var(--ca-primary, #0e2e80);\n  background: var(--ca-surface-hover, #f8faff);\n}\n\n.btn-primary:disabled,\n.btn-secondary:disabled {\n  cursor: not-allowed;\n  opacity: 0.55;\n}\n\n.btn-primary:focus-visible,\n.btn-secondary:focus-visible,\n.asset-tab:focus-visible {\n  outline: 3px solid rgba(40, 80, 173, 0.25);\n  outline-offset: 2px;\n}\n\n.search-toolbar {\n  display: grid;\n  grid-template-columns: minmax(16rem, 1.5fr) minmax(13rem, 0.85fr) auto;\n  gap: 0.75rem;\n  margin-bottom: 1.1rem;\n}\n\n.search-field {\n  display: flex;\n  min-width: 0;\n  align-items: stretch;\n}\n\n.search-control {\n  width: 100%;\n  min-width: 0;\n  min-height: 2.65rem;\n  border: 1px solid var(--ca-input-border, #dfe4ec);\n  border-radius: var(--ca-radius-md, 8px);\n  background: var(--ca-input-bg, #fff);\n  color: var(--ca-text-primary, #172033);\n  font-size: 0.875rem;\n}\n\n.search-control:focus {\n  border-color: var(--ca-input-focus, #2850ad);\n  box-shadow: 0 0 0 0.2rem rgba(40, 80, 173, 0.15);\n  outline: 0;\n}\n\n.search-control::placeholder {\n  color: var(--ca-text-muted, #8c96a8);\n}\n\n.search-field .search-control {\n  border-top-right-radius: 0;\n  border-bottom-right-radius: 0;\n}\n\n.search-submit {\n  display: inline-grid;\n  width: 2.75rem;\n  flex: 0 0 2.75rem;\n  place-items: center;\n  border: 1px solid var(--ca-primary, #0e2e80);\n  border-radius: 0 var(--ca-radius-md, 8px) var(--ca-radius-md, 8px) 0;\n  background: var(--ca-primary, #0e2e80);\n  color: #fff;\n  cursor: pointer;\n  transition: background-color 0.15s ease;\n}\n\n.search-submit:hover {\n  background: var(--ca-primary-dark, #0d2863);\n}\n\n.clear-search {\n  align-self: stretch;\n}\n\n.table-region {\n  min-width: 0;\n  overflow: hidden;\n}\n\n.main-table-wrapper {\n  width: 100%;\n  min-width: 0;\n  max-width: 100%;\n  overflow-x: auto;\n  border: 1px solid var(--ca-border-light, #e9edf3);\n  border-radius: var(--ca-radius-md, 8px);\n}\n\n.table-responsive {\n  max-width: 100%;\n  border: 1px solid var(--ca-border-light, #e9edf3);\n  border-radius: var(--ca-radius-md, 8px);\n}\n\n.assets-table {\n  min-width: 1050px;\n  margin: 0;\n  color: var(--ca-text-primary, #172033);\n  font-size: 0.82rem;\n}\n\n.assets-table thead th {\n  padding: 0.9rem 0.75rem;\n  border-bottom: 1px solid var(--ca-border, #dfe4ec);\n  background: var(--ca-bg-secondary, #eef2f8);\n  color: var(--ca-text-secondary, #4b5870);\n  font-size: 0.69rem;\n  font-weight: 750;\n  letter-spacing: 0.035em;\n  text-transform: uppercase;\n  white-space: nowrap;\n}\n\n.assets-table tbody td {\n  max-width: 19rem;\n  padding: 0.8rem 0.75rem;\n  border-bottom: 1px solid var(--ca-border-light, #e9edf3);\n  color: var(--ca-text-secondary, #4b5870);\n  vertical-align: middle;\n}\n\n.assets-table tbody tr:last-child td {\n  border-bottom: 0;\n}\n\n.assets-table tbody tr {\n  transition: background-color 0.15s ease;\n}\n\n.assets-table tbody tr:hover {\n  background: var(--ca-surface-hover, #f8faff);\n}\n\n.assets-table td.primary-cell {\n  color: var(--ca-text-primary, #172033);\n  font-weight: 650;\n}\n\n.identifier-cell {\n  display: inline-block;\n  max-width: 18rem;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  vertical-align: bottom;\n  white-space: nowrap;\n}\n\n.status-pill {\n  display: inline-flex;\n  align-items: center;\n  max-width: 100%;\n  padding: 0.25rem 0.55rem;\n  border: 1px solid var(--ca-border, #dfe4ec);\n  border-radius: 999px;\n  background: var(--ca-bg-secondary, #eef2f8);\n  color: var(--ca-text-secondary, #4b5870);\n  font-size: 0.7rem;\n  font-weight: 700;\n  line-height: 1.2;\n  white-space: nowrap;\n}\n\n.status-good {\n  border-color: #b7e3ca;\n  background: #eaf7f0;\n  color: #198754;\n}\n\n.status-warning {\n  border-color: #f3d79b;\n  background: #fff7e6;\n  color: #986400;\n}\n\n.status-danger {\n  border-color: #f3b9c0;\n  background: #fdecef;\n  color: #b42332;\n}\n\n.status-neutral {\n  border-color: var(--ca-border, #dfe4ec);\n  background: var(--ca-bg-secondary, #eef2f8);\n  color: var(--ca-text-secondary, #4b5870);\n}\n\n.inline-loading {\n  display: flex;\n  min-height: 4.5rem;\n  align-items: center;\n  gap: 0.65rem;\n  color: var(--ca-text-secondary, #4b5870);\n  font-size: 0.875rem;\n}\n\n.inline-error {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  flex-wrap: wrap;\n  gap: 0.75rem;\n  margin: 0.75rem 0;\n  padding: 0.85rem 1rem;\n  border: 1px solid var(--ca-danger, #dc3545);\n  border-radius: var(--ca-radius-md, 8px);\n  background: var(--ca-danger-bg, #fdecef);\n  color: var(--ca-text-primary, #172033);\n  font-size: 0.85rem;\n}\n\n.inline-retry {\n  padding: 0;\n  border: 0;\n  background: transparent;\n  color: var(--ca-primary, #0e2e80);\n  font-weight: 700;\n  text-decoration: underline;\n  cursor: pointer;\n}\n\n.state-panel,\n.no-results {\n  display: flex;\n  min-height: 15rem;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  gap: 0.65rem;\n  padding: 2rem 1rem;\n  color: var(--ca-text-tertiary, #6f7b91);\n  text-align: center;\n}\n\n.state-panel > i,\n.no-results > i {\n  color: var(--ca-primary-light, #2850ad);\n  font-size: 2rem;\n}\n\n.state-panel h3,\n.no-results h3 {\n  margin: 0;\n  color: var(--ca-text-primary, #172033);\n  font-size: 1rem;\n  font-weight: 700;\n}\n\n.state-panel p,\n.no-results p {\n  max-width: 30rem;\n  margin: 0 0 0.5rem;\n  color: var(--ca-text-secondary, #4b5870);\n  font-size: 0.875rem;\n  line-height: 1.6;\n}\n\n.error-state > i {\n  color: var(--ca-danger, #dc3545);\n}\n\n.loading-spinner {\n  display: inline-block;\n  width: 2rem;\n  height: 2rem;\n  border: 3px solid var(--ca-border, #dfe4ec);\n  border-top-color: var(--ca-primary, #0e2e80);\n  border-radius: 50%;\n  animation: assets-view-spin 0.8s linear infinite;\n}\n\n.loading-spinner-sm {\n  width: 1.1rem;\n  height: 1.1rem;\n  border-width: 2px;\n}\n\n.list-footer {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 1rem;\n  margin-top: 1.15rem;\n  padding-top: 1rem;\n  border-top: 1px solid var(--ca-border-light, #e9edf3);\n}\n\n.pagination-summary {\n  color: var(--ca-text-tertiary, #6f7b91);\n  font-size: 0.78rem;\n}\n\n@keyframes assets-view-spin {\n  to { transform: rotate(360deg); }\n}\n\n@media (max-width: 1100px) {\n  .list-heading {\n    flex-direction: column;\n    align-items: stretch;\n  }\n\n  .verification-actions {\n    justify-content: flex-start;\n  }\n\n  .search-toolbar {\n    grid-template-columns: minmax(0, 1fr) minmax(12rem, 0.8fr);\n  }\n\n  .clear-search {\n    grid-column: 1 / -1;\n    justify-self: start;\n  }\n}\n\n@media (max-width: 767.98px) {\n  .breadcrumb {\n    margin: 0.75rem 1rem 0;\n  }\n\n  .assets-view-page {\n    padding: 0.75rem 1rem 1.25rem;\n  }\n\n  .page-header {\n    align-items: flex-start;\n    flex-direction: column;\n  }\n\n  .page-header-meta {\n    align-self: flex-start;\n  }\n\n  .asset-tabs {\n    gap: 0.1rem;\n    padding-inline: 0.5rem;\n  }\n\n  .asset-tab {\n    flex: 1 1 50%;\n    gap: 0.4rem;\n    padding-inline: 0.45rem;\n    font-size: 0.8rem;\n  }\n\n  .tab-panel {\n    padding: 0.9rem;\n  }\n\n  .verification-actions {\n    display: grid;\n    grid-template-columns: minmax(0, 1fr);\n  }\n\n  .verification-actions .btn {\n    justify-content: flex-start;\n    white-space: normal;\n  }\n\n  .search-toolbar {\n    grid-template-columns: minmax(0, 1fr);\n  }\n\n  .clear-search {\n    grid-column: auto;\n    justify-self: start;\n  }\n\n  .list-footer {\n    align-items: stretch;\n    flex-direction: column;\n  }\n\n  .list-footer app-pagination {\n    align-self: flex-end;\n    max-width: 100%;\n  }\n}\n\n@media (prefers-reduced-motion: reduce) {\n  *,\n  *::before,\n  *::after {\n    animation-duration: 0.01ms !important;\n    animation-iteration-count: 1 !important;\n    scroll-behavior: auto !important;\n    transition-duration: 0.01ms !important;\n  }\n}\n\n\n/* Verification-result modal content rendered through MatDialog. */\n.verification-result-dialog {\n  padding: 2rem;\n  text-align: center;\n}\n\n.verification-result-icon {\n  display: grid;\n  width: 3.5rem;\n  height: 3.5rem;\n  place-items: center;\n  margin: 0 auto 1rem;\n  border: 1px solid var(--ca-border-light, #e9edf3);\n  border-radius: 50%;\n  background: var(--ca-bg-secondary, #eef2f8);\n  color: var(--ca-text-secondary, #4b5870);\n  font-size: 1.8rem;\n}\n\n.verification-result-icon.is-success {\n  border-color: #b7e3ca;\n  background: #eaf7f0;\n  color: #198754;\n}\n\n.verification-result-icon.is-error {\n  border-color: #f3b9c0;\n  background: #fdecef;\n  color: #b42332;\n}\n\n.verification-result-dialog h2 {\n  margin: 0 0 0.65rem;\n  color: var(--ca-text-primary, #172033);\n  font-size: 1.2rem;\n  font-weight: 700;\n}\n\n.verification-result-dialog p {\n  margin: 0;\n  color: var(--ca-text-secondary, #4b5870);\n  font-size: 0.92rem;\n  line-height: 1.6;\n  overflow-wrap: anywhere;\n}\n\n.verification-result-actions {\n  display: flex;\n  justify-content: center;\n  margin-top: 1.5rem;\n}\n\n.verification-result-actions .btn {\n  min-width: 8rem;\n}\n\n.verification-actions .loading-spinner-sm {\n  flex: 0 0 auto;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
